import { render, staticRenderFns } from "./communiquer-sur-internet-google-my-business-cest-quoi.vue?vue&type=template&id=3a8e7e72&"
import script from "./communiquer-sur-internet-google-my-business-cest-quoi.vue?vue&type=script&lang=js&"
export * from "./communiquer-sur-internet-google-my-business-cest-quoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports